import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

import { GlobalCleanupConfigurationInfoView } from "@app/shared/models/administration/cleanup/GlobalCleanupConfigurationInfoView";
import { ComboKeysView } from "@app/shared/models/ComboKeysView";

import { default as constantsFile } from '@app/shared/constants.json';

@Component({
    selector: 'app-administration-cleanup-form',
    templateUrl: './automation-cleanup-form.component.html',
    styleUrls: ['./automation-cleanup-form.component.scss'],
    standalone: false
})
export class AutomationCleanupFormComponent {

  public constants: any = constantsFile.constants;
  public daysOfTheWeekList: Array<string> = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday" ];
  public daysOfTheWeekTranslated: Array<ComboKeysView> = [];
  public startHourDefault: Date = new Date();
  public pattern = this.constants.pattern;

  @Input() genericCleanupView: GlobalCleanupConfigurationInfoView;

  @ViewChild('genericCleanupForm') genericCleanupForm: NgForm;

  constructor(
    private translate: TranslateService
  ) {}

  ngOnInit(){
    this.translateDays();
  }

  private translateDays(){
    this.daysOfTheWeekList.forEach((day) => this.daysOfTheWeekTranslated.push({ keyValue: day, keyTranslated: this.translate.instant(day) }));
  }

  ngOnDestroy(){

  }
}
